import router, {generateRoutes} from "@/router/index";
import {getToken, removeToken} from "@/utils/auth";
import store from "@/store";
import {getRouters} from "@/api/router";
import {formatCourse} from "@/router/format";

// const whiteList = ["/login", "/404", "/home", "/home/index", "/home/simulation", "/home/course"];
// const whiteList = ["/login", "/404", "/register", "/index", "/simulation/simulationindex", "/course/courseindex"];
// 无需加载动态路由即可放行的页面；其余页面游客态也会加载动态路由后放行，保证头部菜单可用
const whiteList = ["/login", "/404", "/register"];

// 最近访问页面的存储 key，用于已登录访问 /login 时跳回来源页
const LAST_ROUTE_KEY = "lastRoute";

// 记录最近访问的页面（登录页/注册页/404 除外）
router.afterEach((to) => {
  if (!whiteList.includes(to.path)) {
    sessionStorage.setItem(LAST_ROUTE_KEY, to.fullPath);
  }
});

// 已登录访问 /login 时的跳转目标：只接受站内路径，避免跳回登录页或站外地址
function resolveLoginRedirect(redirect) {
  return typeof redirect === "string" &&
    redirect.startsWith("/") &&
    !redirect.startsWith("//") &&
    redirect.split(/[?#]/)[0] !== "/login"
    ? redirect
    : "";
}

// 拉取并注册动态路由：游客态同样需要，否则头部菜单没有数据
async function loadDynamicRoutes() {
  const { data } = await getRouters();
  await generateRoutes(formatCourse(data));
}

router.beforeEach(async (to, from, next) => {
  // console.log(`路由守卫 - to: ${to.path}, from: ${from.path}`);
  const token = getToken();

  // 检查是否已经有路由
  const hasRoutes = store.state.route.routes?.length > 0;
  console.log(`路由守卫 - 已有路由: ${hasRoutes ? '是' : '否'}, 路由数量: ${store.state.route.routes?.length || 0}`);

  if (token) {
    console.log('路由守卫 - 已登录状态处理');
    if (to.path === "/login") {
      // 已登录时访问/login：保留登录态，优先按 redirect 参数跳回，否则跳回最近访问的页面
      const redirect = resolveLoginRedirect(to.query.redirect) ||
        resolveLoginRedirect(sessionStorage.getItem(LAST_ROUTE_KEY)) ||
        "/";
      next({ path: redirect, replace: true });
    } else {

      if (hasRoutes) {
        next();
      } else {
        try {
          // 调用个人信息接口
          await store.dispatch("user/fetchUserInfo");

          await loadDynamicRoutes();
          // 动态路由添加完成后，重新导航到原始目标
          next({ ...to, replace: true });
        } catch (e) {
          // 清除token并跳转登录页
          // await store.dispatch('user/resetToken')
          removeToken()
          // 同步清理 Vuex 中的用户信息与动态路由，避免残留状态影响下次登录
          store.commit("user/RESET_USER");
          store.commit("user/SET_ROLES", []);
          store.commit("route/RESET_ROUTES");
          next(`/login?redirect=${encodeURIComponent(to.fullPath)}`);
        }
      }
    }
  } else {
    // 未登录状态：登录/注册/404 直接放行；其余页面加载动态路由后放行，
    // 保证头部菜单可见且菜单项可以点开
    if (whiteList.includes(to.path)) {
      next();
    } else if (hasRoutes) {
      next();
    } else {
      try {
        await loadDynamicRoutes();
        // 动态路由添加完成后，重新导航到原始目标
        next({ ...to, replace: true });
      } catch (e) {
        // 路由接口异常时降级放行，不阻断页面；业务接口的 401 仍由 session.js 引导登录
        next();
      }
    }
  }
});
